import { Action } from '@ngrx/store';

import { BaseFormConfig } from '../models/base-form-config';
import { PumpingServiceInfo } from '@ordersnproducts/modules/shared/models/pumping-service-info';

export const LOAD_PUMPING_SERVICE = '[Specification] Load Pumping Service';
export const LOAD_PUMPING_SERVICE_COMPLETE = '[Specification] Load Pumping Service complete';
export const LOAD_CONFIG_PUMP_COMPLETE = '[Specification] Load Config Pump Complete';
export const REMOVE_PUMPING_FORMS = '[Specification] Remove pumping forms';

export class SpecificationLoadPumpingServiceAction implements Action {
  readonly type = LOAD_PUMPING_SERVICE;

  constructor(public payload: any) {}
}

export class SpecificationLoadPumpingServiceCompleteAction implements Action {
  readonly type = LOAD_PUMPING_SERVICE_COMPLETE;

  constructor(public payload: PumpingServiceInfo) {}
}

export class SpecificationLoadConfigPumpCompleteAction implements Action {
  readonly type = LOAD_CONFIG_PUMP_COMPLETE;

  constructor(public payload: BaseFormConfig) {}
}

export class RemovePumpingFormsForProductAction implements Action {
  readonly type = REMOVE_PUMPING_FORMS;

  constructor(public payload: number | string) {}
}

export type CemexPumpActions =
  | SpecificationLoadConfigPumpCompleteAction
  | SpecificationLoadPumpingServiceAction
  | SpecificationLoadPumpingServiceCompleteAction
  | RemovePumpingFormsForProductAction;
